$( document ).ready(function() {
  $('.product-set__items').find('input[name="set_item_quantity"]').val(0);
  $('.product-set__nav-item').click(function() {
      $('.product-set__nav-item').removeClass('active');
      $(this).addClass('active');
      if ($(this).hasClass('product-set__nav-item--customize')) {
        $('.product-set__items').find('.item__quantity').addClass('active');
      }else{
        $('.product-set__items').find('input[name="set_item_quantity"]').val(1);
        $('.product-set__items').find('.item__quantity').removeClass('active');
      }
  });

  $('.item__minus').click(function() {
    var inputVal = $(this).siblings('input').val() || 1;
    if ($(this).siblings('input').val() != 0) {
      $(this).siblings('input').val(parseInt(inputVal) - 1);
    }
    checkStonesQuantity();
  });

  $('.item__plus').click(function() {
    var inputVal = $(this).siblings('input').val() || 1;
    $(this).siblings('input').val(parseInt(inputVal) + 1);
    checkStonesQuantity();
  });

  $('input[name="set_item_quantity"]').on('input', function() {
    if ($(this).val() == "") {
      return this.value = 0;
    }      
    checkStonesQuantity();  
  });

  function checkStonesQuantity() {
    var stonesQuantity = 0;
    var itemTotal = 0;
    var itemsTotal = 0;
    $('.Product__neklace-stones > .item').each(function() {
      stonesQuantity = stonesQuantity + parseInt($(this).find('input[name="set_item_quantity"]').val());
      var itemQuantity = parseInt($(this).find('input[name="set_item_quantity"]').val());
      var itemPrice = parseInt($(this).find('.item__price').data('price'));
      itemTotal = itemQuantity * itemPrice;
      itemsTotal = itemsTotal + itemTotal;
    }).promise().done(function() {
      if (stonesQuantity > 4) {
        $('.Product__necklace-button-total').data('items', 'sztuk')
      }
      $('.Product__necklace-button-total').empty().html(stonesQuantity + " " + $('.Product__necklace-button-total').data('items') + " - " + (itemsTotal / 100 ) + " " + Shopify.currency.active);
    });
    if (stonesQuantity > 2) {
      $('.Product__necklace-button').removeClass('disabled').removeAttr("disabled");
      $('.Product__necklace-button-tooltip').removeClass('active');
    }else{
      $('.Product__necklace-button').addClass('disabled').attr("disabled", "disabled");
    }

  }
  checkStonesQuantity();

  $('.Product__necklace-button').click(function() {
    if (!$(this).hasClass('disabled')) {
      var setItems = [];
      var itemsTotal = 0;
      const setId = (Math.random() + 1).toString(36).substring(7);
      $('.Product__neklace-stones > .item').each(function() {
        var itemVariantID = $(this).data('id');
        var itemQuantity = $(this).find('input[name="set_item_quantity"]').val();
        if (Number(itemQuantity) <= 0) {
          return;
        }
        setItems.push({ quantity: itemQuantity, id: itemVariantID, properties: {
          _setId: `#${setId}`
        } });
      }).promise().done(function() {        
        jQuery.post(window.Shopify.routes.root + 'cart/add.js', {
          items: setItems  
        }).done(function(data) {
          document.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1,
              },
            })
          );      
        }).fail(function(data) {
          var response = JSON.parse(data.responseText);
          if (response.status == 422) {
            $('.Product__necklace__messages').empty().append(response.description);
          }
        }).always(function(data) {

        });
        $('.Product__necklace-button-tooltip').removeClass('active');
      });
    }else{
        $('.Product__necklace-button-tooltip').addClass('active');
    }
  });

  $('.show_remaining_colors').click(function(){
    $('.product__color-switch-colors .hidden').removeClass('hidden');
    $('.show_remaining_colors').hide();
  });

  // $('.product__variants--collection > .item').click(function(e) {
  //   e.preventDefault();
  //   var variantURL = $(this).attr('href');
  //   $(this).closest('.ProductItem').find('.ProductItem__Title > a, .ProductItem__ImageWrapper').attr('href', variantURL);
  //   $(this).siblings().removeClass('active');
  //   $(this).addClass('active');
  //   var variantImage = $(this).closest('.ProductItem').find('.ProductItem__Colour-images > div').eq($(this).index()).data('image');
  //   if (variantImage !== undefined) {
  //     $(this).closest('.ProductItem').find('.ProductItem__Image').attr('srcset', '').attr('src', variantImage);
  //   }    
  // });
    

});